import * as styles from "./ClipboardButton.css";

import { CopyButton } from "@frontend/components/atoms/CopyButton";
import { useLingui } from "@lingui/react/macro";

export function ClipboardButton({ value }: { value: string }) {
  const { t } = useLingui();

  return (
    <CopyButton
      value={value}
      label={t`Copy`}
      copiedLabel={t`Copied`}
      variant="ghost"
      className={styles.button}
    />
  );
}
